<template>
  <div>
    <div class="title-h3 title-bar">구성 정보</div>
    <hr class="mr-b20" />
    <el-row v-loading="isLoading" type="flex" justify="space-betwwen" :gutter="20">
      <el-col :span="24">
        <el-row :gutter="20">
          <el-col :span="8">
            <!-- 기본정보 -->
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">기본 정보</div>
              <div class="list form-list">
                <el-form ref="configForm" :model="formData" label-width="140px">
                  <el-form-item label="장비명">
                    <w-text-form :modifiable="false" :target="formData" property="objName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="가상화 벤더">
                    <w-text-form :modifiable="false" :target="formData" property="basicinfoSubname"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="장비 종류">
                    <w-text-form :modifiable="false" :target="formData" property="objtypeName"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유형">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_COMMON/TYPE"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="중요도">
                    <w-obj-importance-form-editor :modifiable="modifiable" :target="formData" property="objImportance"> </w-obj-importance-form-editor>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <!-- HW/SW 정보 -->
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">HW/SW 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="140px">
                  <el-form-item label="스토리지 수">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_COMMON/STORAGE_COUNT"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="전체용량">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_STORAGE/TOTAL_CAPACITY"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="VMDK 수">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_COMMON/VMDK_COUNT"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="스냅샷 수">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_COMMON/SNAPSHOT_COUNT"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="I/O 매트릭">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_DRS/IO_MATRIC"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="스토리지 DRS">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_COMMON/DRS_MODE"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="자동화 수준">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_DRS/DRS_AUTO_LEVEL"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="사용된 공간 임계값">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_DRS/USED_SPACE_THRESHOLD"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="I/O 지연 시간 임계값">
                    <w-text-form :modifiable="false" :target="formData" property="VDSC_DRS/IO_WAIT_TIME_THRESHOLD"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
          <el-col :span="8">
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">관리자/유지보수 정보</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="관리자(정)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMajor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMajor) }} </span>
                  </el-form-item>
                  <el-form-item label="관리자(부)">
                    <el-select v-if="modifiable" ref="selectEditor" v-model="formData.objManagerIdMinor" :filterable="true" default-first-option controls-position="right" size="mini" clearable>
                      <el-option v-for="option in managerList" :key="option.managerId" :label="option.mapLabel" :value="option.managerId"> </el-option>
                    </el-select>
                    <span v-else> {{ getObjManagerName(formData.objManagerIdMinor) }} </span>
                  </el-form-item>
                  <el-form-item label="유지보수 업체">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceCompany"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 담당자">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceManager"> </w-text-form>
                  </el-form-item>
                  <el-form-item label="유지보수 연락처">
                    <w-text-form :modifiable="modifiable" :target="formData" property="maintenanceTel"> </w-text-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
            <el-row class="mr-b30">
              <div class="title-h4 title-bar">이벤트 제외 설정</div>
              <div class="list form-list">
                <el-form :model="formData" label-width="120px">
                  <el-form-item label="이벤트 제외">
                    <w-check-form :modifiable="modifiable" :target="formData" property="eventExceptFlag"> </w-check-form>
                  </el-form-item>
                </el-form>
              </div>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// for edit cmp
import { mapGetters } from 'vuex';
import { cloneDeep, isNil, isEmpty } from 'lodash';
import WTextForm from '@/components/formeditor/TextFormEditor';
import WCheckForm from '@/components/formeditor/CheckFormEditor';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import perfApi from '@/api/virtual/performance/config';
import commonAPI from '@/api/config/common';
import MsgUtil from '@/utils/message';
import WObjImportanceFormEditor from '@/components/formeditor/ObjImportanceFormEditor';

export default {
  name: 'WConfigStatus',
  components: {
    WTextForm,
    WCheckForm,
    WObjImportanceFormEditor,
  },
  props: {
    nodeParams: Object,
    activeTab: String,
  },
  data() {
    return {
      isLoading: true,
      formData: {}, // Form 바인딩 데이터
      formDataOrigin: {},
      managerList: [],
    };
  },
  computed: {
    ...mapGetters(['rejectConfigEditing', 'saveConfigEditing']),
    modifiable() {
      return this.$store.state.config.isConfigEditing;
    },
    params() {
      return {
        objId: this.nodeParams.objId,
        objtypeId: this.nodeParams.objtypeId,
      };
    },
  },
  watch: {
    activeTab: {
      immediate: true,
      handler(tabName) {
        if (tabName === this.$options.name) {
          this.loadData();
        }
      },
    },
    params: {
      immediate: true,
      handler() {
        if (this.modifiable) {
          // 대상 변경 시 수정모드 종료
          this.$store.dispatch('setConfigEditing', false);
        }
        this.loadData();
      },
    },
    rejectConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.formData = Object.assign({}, this.formDataOrigin);
          this.$store.dispatch('initRejectConfig');
        }
      },
    },
    saveConfigEditing: {
      immediate: true,
      handler(to) {
        if (to) {
          this.$refs.configForm.validate((valid) => {
            if (valid) {
              this.$confirm(...MsgUtil.getBasicConfirmData(MsgUtil.action.SAVE))
                .then(() => {
                  const formData = this.formData;
                  const infoParams = Object.assign({}, formData);
                  const modifiedData = formData.modified;

                  const updateDate = {
                    objId: infoParams.objId,
                    objName: infoParams.objName,
                    objImportance: formData.objImportance, // null이면 delete로 판단하므로 값 변경이 없을 경우에도 서버단에 전달한다.
                    objtypeId: this.params.objtypeId,
                  };
                  if (modifiedData && Object.keys(modifiedData).length > 0) {
                    Object.keys(modifiedData).forEach((key) => {
                      updateDate[key] = formData[key];
                    });
                  }
                  updateDate.objManagerIdMajor = formData.objManagerIdMajor;
                  updateDate.objManagerIdMinor = formData.objManagerIdMinor;

                  const target = '구성 정보';
                  const action = MsgUtil.action.SAVE;
                  perfApi
                    .updateVmsObjConfig(updateDate)
                    .then((result) => {
                      if (result.data.success) {
                        this.$message(MsgUtil.getResultMsgData(action, target, true));
                        this.$store.dispatch('endConfigEdit');
                        this.loadData();
                      } else {
                        this.$message(MsgUtil.getResultMsgData(action, target, false));
                      }
                    })
                    .catch((e) => {
                      this.$message(MsgUtil.getResultMsgData(action, target, true));
                      throw new Error(e);
                    });
                  this.$store.dispatch('endConfigEdit');
                })
                .catch(() => {
                  this.$store.dispatch('setSaveConfigEditing', false);
                });
            } else {
              this.$store.dispatch('setSaveConfigEditing', false);
            }
          });
        }
      },
    },
  },
  methods: {
    convertValuByUnit,
    loadData() {
      this.isLoading = true;
      perfApi
        .getNodeConfigInfoForObjtype(this.params)
        .then((response) => {
          if (response.data.success && response.data.data.length > 0) {
            this.convertSizeForHW(response, 'VDSC_STORAGE/TOTAL_CAPACITY', 'MB', 'B'); // 전체용량
            this.convertSizeForHW(response, 'VDSC_DRS/USED_SPACE_THRESHOLD', '%', '%'); // 사용된 공간 임계값
            this.convertSizeForHW(response, 'VDSC_DRS/IO_WAIT_TIME_THRESHOLD', 'ms', 'ms'); // I/O 지연 시간 임계값
            this.formDataOrigin = cloneDeep(response.data.data[0]);
            this.formData = response.data.data[0];
            this.$emit('setConfigData', this.formData);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
      commonAPI.getMgrInfoList({}).then((res) => {
        this.managerList = res.data.data;
      });
    },
    // 단위변환
    convertSizeForHW(response, key, unit, unitTail) {
      response.data.data[0][key] = isNil(Number(response.data.data[0][key])) ? EMPTY_TEXT : `${convertValuByUnit(Number(response.data.data[0][key]), unit, true, false, true)}${unitTail}`;
    },
    /**
     * managerName 조회
     * @param  {[type]} managerId [description]
     * @return {[type]}           [description]
     * @author jda
     */
    getObjManagerName(managerId) {
      if (isEmpty(managerId)) {
        return EMPTY_TEXT;
      }
      const mgrInfo = this.managerList.find((data) => data.managerId === managerId);
      return isEmpty(mgrInfo) ? EMPTY_TEXT : mgrInfo.managerName;
    },
  },
};
</script>

<style>
.form-list .el-form-item__label {
  text-align: left;
}

.form-header {
  padding-left: 10px;
  height: 25px;
  font-weight: bold;
  font-size: 14px;
  color: #8b8b8b;
}
</style>



// WEBPACK FOOTER //
// src/views/config/node/virtual/storagecluster/configstatus/index.vue